import { SearchParamKeys } from './constants';

const encodeParam = (param: string | undefined, routerKey: string) =>
    param != null ? encodeURIComponent(param) : `:${routerKey}`;

export const AppRoutes = {
    callback: '/callback',
    loggedOut: '/logged-out',
    home: '/home',
    products: '/products',
    productDetails: (
        oid = ':oid',
        isBrand: string | boolean = ':isBrand',
        referentPriceType = ':referentPriceType',
    ) => `/products/${oid}/${isBrand}/${referentPriceType}`,
    prescribers: '/prescribers',
    prescriberDetails: (npi = ':npi') => `/prescribers/${npi}`,
    treatments: '/treatments',
    treatmentDetails: (treatmentId?: string) =>
        `/treatments/${encodeParam(treatmentId, 'treatmentId')}`,
    referrals: '/referrals',
    referralDetails: (referralId = ':referralId') => `/referrals/${referralId}`,
    pharmacies: '/pharmacies',
    pharmacyDetails: (npi = ':npi') => `/pharmacies/${npi}`,
    requests: '/requests',
    requestDetails: (requestId = ':requestId') => `/requests/${requestId}`,
    admin: '/admin',
    teamNotifications: '/admin/team-notifications',
    clinicalPolicies: '/admin/policies',
    clinicalPolicyDetails: (draftId = ':draftId') => `/admin/policies/${draftId}`,
    termsOfUse: '/terms-of-use',
    privacyPolicy: '/privacy-policy',
    updatesHistory: '/updates-history',
    requestDetailsWithPayer: (requestId = ':requestId', payerId = ':payerId') =>
        `/requests/${requestId}?${SearchParamKeys.PAYER_ID}=${payerId}`,
} as const;
